import React from 'react';
import { Controller } from 'react-hook-form';

import useFormContext from './useFormContext';


function createField(Component) {
  function Wrapper(props) {
    const { name, error = false, helperText = '', ...restProps } = props;

    const { control } = useFormContext();

    const renderField = ({ field, fieldState }) => {
      const props = {
        error: Boolean(fieldState.error) || error,
        helperText: fieldState.error?.message || helperText || ' ',
        ...restProps,
        ...field,
      };

      return React.createElement(Component, props);
    };

    return <Controller name={name} control={control} render={renderField} />;
  }

  Wrapper.displayName = `${Component.displayName}(Generic)`;
  return Wrapper;
}

export default createField;
